import { __awaiter, __generator } from "tslib";
import { debug } from 'shared/utils';
/**
 * Conditionally load feed module when feed info exists
 */
var feedLoader = function () { return __awaiter(void 0, void 0, void 0, function () {
    var ad, module_1, _a, e_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                ad = window.ADAPT.ad;
                if (!ad.feed) {
                    return [2 /*return*/];
                }
                _b.label = 1;
            case 1:
                _b.trys.push([1, 4, , 5]);
                return [4 /*yield*/, import(
                    /* webpackChunkName: "feed" */ './processFeed')];
            case 2:
                module_1 = _b.sent();
                _a = window.ADAPT;
                return [4 /*yield*/, module_1.processFeed(ad)];
            case 3:
                _a.ad = _b.sent();
                return [3 /*break*/, 5];
            case 4:
                e_1 = _b.sent();
                debug('failed to load feed module', e_1);
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}); };
export default feedLoader;
